var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (fieldsetCounter, globals, id) {
      







































































































































































pug_mixins["radio"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.title && attributes.name) {
attributes.title = attributes.name
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key + '-' + attributes.index
}
pug_html = pug_html + "\u003Cinput" + (pug.attr("class", pug.classes([attributes.fieldHtmlClass], [true]), false, true)+pug.attr("id", id, true, true)+" type=\"radio\""+pug.attr("required", attributes.required, true, true)+pug.attr("name", attributes.key, true, true)+pug.attr("ng-model", attributes.key, true, true)+pug.attr("ng-disabled", attributes.readonly, true, true)+pug.attr("value", attributes.value, true, true)+pug.attr("ng-value", attributes['ng-value'], true, true)+pug.attr("data-cy", attributes['data-cy'], true, true)+pug.attr("ng-change", attributes['ng-change'], true, true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (" class=\"radio-inline\""+pug.attr("for", attributes.key + '-' + attributes.index, true, true)) + "\u003E\u003Cspan\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E";
}
};






































































pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (!fieldsetCounter) {
fieldsetCounter = 0
}





















pug_html = pug_html + "\u003Cdiv class=\"meineakte-mpp row\" id=\"meineakte-mpp\"\u003E\u003Cdiv class=\"xsmall-12 columns\"\u003E\u003Cdiv class=\"row\" ng-if=\"$ctrl.loading.main\"\u003ELaden\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-repeat=\"pc_component in $ctrl.neo_pc_components\" ng-if=\"!$ctrl.loading.main\"\u003E\u003Cdiv class=\"columns small-12\"\u003E\u003Cdiv class=\"bigbox\"\u003E\u003Cdiv class=\"header\" ng-init=\"open = pc_component.is_active\" ng-click=\"open = !open\"\u003E\u003Cspan\u003EPC-Leasing {{ pc_component.contract_start_date_display }} - {{pc_component.contract_end_date_display}} - {{ pc_component.component_state_display }} \u003C\u002Fspan\u003E\u003Cspan class=\"openable\" ng-class=\"{selected: !open}\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\" ng-hide=\"open\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns small-12\"\u003E\u003Cdiv class=\"mainWrapper\"\u003E\u003Cdiv class=\"vn-table\"\u003E\u003Ctable\u003E\u003Ctbody\u003E\u003Ctr\u003E\u003Ctd\u003E\u003Cspan\u003EBestellstatus\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cspan\u003E{{ pc_component.order_process_display || '-' }}\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr\u003E\u003Ctd\u003E\u003Cspan\u003EBeginn\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cspan\u003E{{ pc_component.contract_start_date_display || '-' }}\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr\u003E\u003Ctd\u003E\u003Cspan\u003EEnde\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cspan\u003E{{ pc_component.contract_end_date_display || '-' }}\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr\u003E\u003Ctd\u003E\u003Cspan\u003EMonatliche Umwandlungsrate\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cspan\u003E{{ pc_component.per_month_value | currency }}\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr\u003E\u003Ctd\u003E\u003Cspan\u003EAuftragsnummer Lieferant\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cspan\u003E{{ pc_component.order_id || '-'}}\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr\u003E\u003Ctd\u003E\u003Cspan\u003ELeasingvertragsnummer\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cspan\u003E{{ pc_component.contract_id || '-' }}\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003C\u002Ftbody\u003E\u003C\u002Ftable\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns small-12 side-effect\"\u003E\u003Cbasket-overview-checkout-component basket=\"pc_component.basket\" errors=\"$ctrl.errors\" options=\"{to_validate: false}\"\u003E\u003C\u002Fbasket-overview-checkout-component\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"iframe-popup-trigger\"\u003E\u003Ca class=\"button button-primary\" magnific-popup=\"{type: &quot;iframe&quot;}\" ng-href=\"https:\u002F\u002Fform.asana.com\u002F?k=lBmtL7GmbTkPmCHH0XUB6w&amp;d=11919111970056&amp;embed=true\"\u003ESchaden melden\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-repeat=\"pc_component in $ctrl.bonus_pc_components\" ng-if=\"!$ctrl.loading.main\"\u003E\u003Cdiv class=\"columns small-12\"\u003E\u003Cdiv class=\"bigbox\"\u003E\u003Cdiv class=\"header\" ng-init=\"open = pc_component.is_active\" ng-click=\"open = !open\"\u003E\u003Cspan\u003EPC-Leasing - BONUS - {{ pc_component.beginDate | date }} - {{pc_component.endDate | date}} - {{$ctrl.MPP_ORDER_STATUSES_BY_ID[pc_component.order_process.state_id].display }}\u003C\u002Fspan\u003E\u003Cspan class=\"openable\" ng-class=\"{selected: !open}\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\" ng-hide=\"open\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns small-12\"\u003E\u003Cdiv class=\"mainWrapper\"\u003E\u003Cdiv class=\"vn-table\"\u003E\u003Ctable\u003E\u003Ctbody\u003E\u003Ctr\u003E\u003Ctd\u003E\u003Cspan\u003EBestellstatus\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cspan\u003E{{$ctrl.MPP_ORDER_STATUSES_BY_ID[pc_component.order_process.state_id].display }}\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr\u003E\u003Ctd\u003E\u003Cspan\u003EBeginn\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cspan\u003E{{ (pc_component.beginDate | date) || '-' }}\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr\u003E\u003Ctd\u003E\u003Cspan\u003EEnde\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cspan\u003E{{ (pc_component.endDate | date) || '-' }}\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr\u003E\u003Ctd\u003E\u003Cspan\u003EMonatliche Umwandlungsrate\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cspan\u003E{{ pc_component.leasing | currency }}\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr\u003E\u003Ctd\u003E\u003Cspan\u003EAuftragsnummer Lieferant\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cspan\u003E{{ pc_component.order_id || '-'}}\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr\u003E\u003Ctd\u003E\u003Cspan\u003ELeasingvertragsnummer\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cspan\u003E{{ pc_component.contract_id || '-' }}\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003C\u002Ftbody\u003E\u003C\u002Ftable\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns small-12 side-effect\"\u003E\u003Cbasket-overview-checkout-component basket=\"pc_component\" errors=\"$ctrl.errors\" options=\"{to_validate: false}\"\u003E\u003C\u002Fbasket-overview-checkout-component\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"iframe-popup-trigger\"\u003E\u003Ca class=\"button button-primary\" magnific-popup=\"{type: &quot;iframe&quot;}\" ng-href=\"https:\u002F\u002Fform.asana.com\u002F?k=lBmtL7GmbTkPmCHH0XUB6w&amp;d=11919111970056&amp;embed=true\"\u003ESchaden melden\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }.call(this, "fieldsetCounter" in locals_for_with ?
        locals_for_with.fieldsetCounter :
        typeof fieldsetCounter !== 'undefined' ? fieldsetCounter : undefined, "globals" in locals_for_with ?
        locals_for_with.globals :
        typeof globals !== 'undefined' ? globals : undefined, "id" in locals_for_with ?
        locals_for_with.id :
        typeof id !== 'undefined' ? id : undefined));
    ;;return pug_html;};
module.exports = template;